 var config;
var dialogWidth, dialogHeight;
jQuery.ajax({
    url: "https://apps.anncode.com/multibuy/api/services/Getconfig"
}).done(function(data) {
    config = data;
  config.isLabelEnabled=true;
  config.isChangeVariantImage=true;
  config.maxQuantity=5;
  config.increment=1;
    if (config !== null) {
        var cartButtonHtml = '<button id="wd-addToCart" class="wd-ma-addtoCart-btn" onclick="addstocart();" >' + config.addToCartButtonText + '</button>';
        //append Cart add success message
        jQuery('body').append('<div id="snackbar"></div>');
        setTimeout(function() {
            jQuery('body').append('<div id="addtocart-container">' + cartButtonHtml + '</div>');
        }, 2500);

        if (Shopify.theme.theme_store_id == '578' || Shopify.theme.theme_store_id == '730' || Shopify.theme.theme_store_id == '766') {
            elemendtoSearch = jQuery('a[href*="/products/"]:not([href*=".jp"]):not(form a[href*="/products/"]):not(.related-products a[href*="/products/"]):not(.not-sca-qv a[href*="/products/"]):not([href*=".JP"]):not([href*=".png"]):not([href*=".PNG"])').has('img[src*="/products/"]:not([class*="not-sca-qv"]),img[src*="/no-image"]')

        } else if(Shopify.theme.theme_store_id == '829' || Shopify.theme.theme_store_id == '679' ||Shopify.theme.theme_store_id == '782' || Shopify.theme.theme_store_id == '766' ||Shopify.theme.theme_store_id == '719' || Shopify.theme.theme_store_id == '775' ||Shopify.theme.theme_store_id == '380' || Shopify.theme.theme_store_id == '796' ) {
            elemendtoSearch = jQuery('a[href*="/products/"]:not([href*=".jp"]):not(form a[href*="/products/"]):not(.related-products a[href*="/products/"]):not(.not-sca-qv a[href*="/products/"]):not([href*=".JP"]):not([href*=".png"]):not([href*=".PNG"])');
        }
	    else{
        //Edit here for non-supported themes
         elemendtoSearch = jQuery('a[href*="/products/"]:not([href*=".jp"]):not(form a[href*="/products/"]):not(.related-products a[href*="/products/"]):not(.not-sca-qv a[href*="/products/"]):not([href*=".JP"]):not([href*=".png"]):not([href*=".PNG"])');
		}

        elemendtoSearch.each(function(index) {
          jQuery(this).find('img:eq(0)').addClass('wd-main-img');


            if (Shopify.theme.theme_store_id == '730' || Shopify.theme.theme_store_id == '766') {
                jQuery(this).parent().parent().css('position', 'relative');
                dialogWidth = jQuery(this).find('img:eq(0)').width();
                dialogHeight = jQuery(this).find('img:eq(0)').height();
            } else {
                jQuery(this).parent().css('position', 'relative');
                dialogWidth = jQuery(this).find('img:eq(0)').width();
                dialogHeight = jQuery(this).find('img:eq(0)').height();

            }

            f = jQuery(this).attr("href").split("/");
            productHandle = f[f.length - 1].split("?")[0];

            var htmlToAppend = "";
            htmlToAppend += "<div>"
            //Add to cart checkbox
           // htmlToAppend += "<div  id='desc_" + productHandle + "' class='wd-descs'  onclick=getProductInformation('" + productHandle + "',this," + index + ",'description') >Desc</div>";

            htmlToAppend += "<input type='checkbox' id='chk_" + productHandle + "' class='wd-quick-view'  onclick=getProductInformation('" + productHandle + "',this," + index + ",'variant') />";
            //Add to cart text label
            htmlToAppend += "<label for='chk_" + productHandle + "' class='wd-ma-addtocart-chkbx'>" + config.checkBoxText + "</label>";
            //Loader Image
            htmlToAppend += "<div class='variant-loader'><img src='" + config.loaderImageUrl + "'  height=8 width=70/></div>";
            //selected Variant detail
            htmlToAppend += "<span class='wd-ma-selected-variants-info' ></span>";

            //Variant Box Container
            htmlToAppend += "<div class='wd-ma-variants-outer' style='width:" + dialogWidth + "px; height:" + dialogHeight + "px; ' >";
            //selected variant id (hidden)
          htmlToAppend += "<div style='width:90%;left:5%;position:absolute;top:50%;top:50%;transform: translateY(-50%);'>";
            htmlToAppend += "<span class='selected-variant-id' style='display:none;'></span>";
            //Variants options
            htmlToAppend += "<div class='variants'></div>";
            htmlToAppend += "<div>";
          if(config.isLabelEnabled){
          htmlToAppend += "<label>Quantity</label>";
          }
            //Quantity dropdown from 1 to 10
            htmlToAppend += "<select  class='qty-box'>";
          for(i=1;i<=config.maxQuantity;i=i+config.increment){
            htmlToAppend +="<option value="+i+">"+i+"</option>";
          }
             htmlToAppend +="</select>";
            htmlToAppend += "</div>";
            htmlToAppend += "<span onclick=javascript:this.parentNode.parentNode.style.display='none'; class='wd-ma-variant-ok-btn'>Ok</span>";
            htmlToAppend += "</div>";
          htmlToAppend += "</div>";
            htmlToAppend += "</div>";
            if (Shopify.theme.theme_store_id == '578') {
                var imgsrc = jQuery(this).find('img').attr('src');
                //alert(imgsrc.indexOf("no-image"))
                if (imgsrc.indexOf("no-image") != -1) {
                    jQuery(this).parent().append(htmlToAppend);
                } else {
                    jQuery(this).parent().parent().append(htmlToAppend);
                }

            } else if (Shopify.theme.theme_store_id == '730' || Shopify.theme.theme_store_id == '766') {
                jQuery(this).parent().parent().append(htmlToAppend);

            } else {
                jQuery(this).after(htmlToAppend);
            }
        });
    }

})

//	
function getProductInformation(handle, elem, index, type) {
  //alert(elem.html())

    //close other variant box if enabled in settings
    if (config.closeOtherVariantbox) {
        jQuery('.wd-ma-variants-outer').hide();
    }

    var selectedVariantId;
    var selectedVariantName;
    var variantQuantityAvailable;
    var variantHtml = jQuery(elem).parent().find('.variants').html();
    var isVar = false;
    var variantBoxDisplay = false;

    //if variant information is not fetched and filled
    if (variantHtml == "") {
        //show loader if enabled in settings
        if (config.variantLoader) {
            jQuery(elem).parent().find('.variant-loader').show();
        }
        jQuery(elem).attr("disabled", true);
        var requestUrl = "/products/" + handle + ".js";
        $.getJSON(requestUrl, function(ProductData) {
            jQuery(elem).parent().after("<script> var prd" + index + "=" + JSON.stringify(ProductData) + "<\/script>");

           // var pDesc = ProductData.description;
            //jQuery(elem).parent().append('<div><div class="wd-desc" style="">' + pDesc + '</div></div>');


            var optionLength = ProductData.options.length;
            for (i = 0; i < optionLength; i++) {
                if (ProductData.options[i].name != "Title") {
                    var select = document.createElement("select");
                    select.id = "opt-" + ProductData.options[i].name;
                    select.setAttribute('onchange', "changeVariant(1," + index + ",eval('prd' + " + index + "))");
                    select.setAttribute('class', 'variant-options');
                    for (j = 0; j < ProductData.options[i].values.length; j++) {
                        var optionVal = ProductData.options[i].values[j];
                        var option = document.createElement("option");
                        option.textContent = optionVal;
                        option.value = optionVal;
                        select.appendChild(option);
                    }
                    variantBoxDisplay = true;
                  if(config.isLabelEnabled){
 					var variantLabel =ProductData.options[i].name;
					 jQuery(elem).parent().find('.variants').append('<label>'+variantLabel+'</label>');
                  }
                    jQuery(elem).parent().find('.variants').append(select);
                    //jQuery(elem).parent().find('.wd-ma-variants-outer').show();
                    if (jQuery(elem).parent().parent().find('.wd-ma-variants-outer').css('display') == 'none') {

                        jQuery(elem).parent().parent().find('.wd-ma-variants-outer').animate({
                            height: 'toggle'
                        }, 290, function() {
                            //jQuery(elem).parent().find('.wd-desc').hide();
                        });
                    }


                    selectedVariantId = ProductData.variants[0].id;
                    selectedVariantName = ProductData.variants[0].title;
                    variantQuantityAvailable = ProductData.variants[0].inventory_quantity;
                    jQuery(elem).parent().find('.wd-ma-selected-variants-info').html(selectedVariantName);
                    jQuery(elem).parent().find('.selected-variant-id').html(selectedVariantId);


                } else {
                    variantBoxDisplay = false;
                    //alert("2")
                    // jQuery(elem).parent().find('.wd-ma-variants-outer').show();
                    if (jQuery(elem).parent().parent().find('.wd-ma-variants-outer').css('display') == 'none') {

                        jQuery(elem).parent().parent().find('.wd-ma-variants-outer').animate({
                            height: 'toggle'
                        }, 290, function() {
                            // jQuery(elem).parent().find('.wd-desc').hide();
                        });

                    }
                    selectedVariantId = ProductData.variants[0].id;
                    selectedVariantName = ProductData.variants[0].title;
                    variantQuantityAvailable = ProductData.variants[0].inventory_quantity;
                    jQuery(elem).parent().find('.variants').append(selectedVariantName);
                    jQuery(elem).parent().find('.variants').hide();
                    if (selectedVariantName != "Default Title") {
                        jQuery(elem).parent().find('.wd-ma-selected-variants-info').html(selectedVariantName);
                    }
                    jQuery(elem).parent().find('.selected-variant-id').html(selectedVariantId);

                }
                jQuery(elem).parent().find('.variant-loader').hide();
                jQuery(elem).removeAttr("disabled");

            }
            changeVariant = function(occur,index, obj) {
                elem = jQuery('.wd-quick-view:eq(' + index + ')');
                setTimeout(function() {
                    var optionLength = obj.options.length;
                    var selectedOptions = [];
                    for (i = 0; i < optionLength; i++) {
                        selectedOptions[i] = elem.parent().find('.variant-options:eq(' + i + ')').val();
                    }
                    var difference = [];
                    var variantPrice;
                    for (j = 0; j < obj.variants.length; j++) {
                        var array2 = obj.variants[j].options;
                        var is_same = selectedOptions.length == array2.length && selectedOptions.every(function(element, index) {
                            return element === array2[index];
                        });
                        if (is_same == true) {
                            variantPrice = obj.variants[j].price / 100;
                            variantPrice = variantPrice.toFixed(2);
                            jQuery('.variant-price').text(variantPrice);
                            selectedVariantId = obj.variants[j].id;
                            elem.parent().find('.selected-variant-id').html(selectedVariantId);
                            selectedVariantName = obj.variants[j].title;
                            variantQuantityAvailable = obj.variants[j].available;
                          //alert(variantQuantityAvailable)
                          if(!variantQuantityAvailable){
                            jQuery(elem).parent().find('.selected-variant-id').html('outofstock');
                            jQuery(elem).parent().find('.wd-ma-selected-variants-info').html('out of stock');
                          
                          }
                          else{
                             jQuery(elem).parent().find('.wd-ma-selected-variants-info').html(selectedVariantName);
                         
                          }
                          if(occur==1 && config.isChangeVariantImage){
                          variantImage=obj.variants[j].featured_image.src;
                        //  alert(variantImage)
                        //  alert(index);
                           jQuery('.wd-main-img:eq('+index+')').removeAttr('srcset');
                           jQuery('.wd-main-img:eq('+index+')').removeAttr('data-srcset');
                          
                          
                          jQuery('.wd-main-img:eq('+index+')').prop('src',variantImage);
                          }
                          /*try{
                           
                          }
                            catch(e){
                            variantImage=null
                          }*/
                            //alert(variantImage)
                         // alert(variantImage);
                         /* if(variantImage){
                          
                           jQuery('.wd-main-img:eq('+index+')').removeAttr('srcset');
                           jQuery('.wd-main-img:eq('+index+')').removeAttr('data-srcset');
                          
                          
                          jQuery('.wd-main-img:eq('+index+')').prop('src',variantImage);
                          
                          }
                          else{
                            variantImage=null;
                          }*/
                          //alert(elem.parent().html());
                        }
                    }
                }, 100)
            }
            changeVariant(0,index, eval('prd' + index));
            if (elem.is(':checked')) {
                if (variantBoxDisplay) {
                    // elem.parent().find('.wd-ma-variants-outer').show();
                    //  alert("3")
                    if (elem.parent().parent().find('.wd-ma-variants-outer').css('display') == 'none') {
                        elem.parent().parent().find('.wd-ma-variants-outer').animate({
                            height: 'toggle'
                        }, 290, function() {});
                    }

                }
                elem.parent().find('.wd-ma-selected-variants-info').css('visibility', 'visible');
            } else {
                elem.parent().find('.wd-ma-selected-variants-info').css('visibility', 'hidden');
            }
        });
    } else {
        if (jQuery(elem).is(':checked')) {
            // jQuery(elem).parent().find('.wd-ma-variants-outer').show();
            //alert("4")
            if (jQuery(elem).parent().parent().find('.wd-ma-variants-outer').css('display') == 'none') {
                jQuery(elem).parent().parent().find('.wd-ma-variants-outer').animate({
                    height: 'toggle'
                }, 290, function() {});
            }
            jQuery(elem).parent().parent().find('.wd-ma-selected-variants-info').css('visibility', 'visible');
        } else {
          
            jQuery(elem).parent().parent().find('.variants-outer').hide();
            jQuery(elem).parent().find('.wd-ma-selected-variants-info').css('visibility', 'hidden');
        }
    }
}

function addItems(t, r, e, k, selectedCount) {
    var r = r || 1,
        a = {
            type: "POST",
            url: "/cart/add.js",
            data: "quantity=" + r + "&id=" + t,
            dataType: "json",
            async: false,
            success: function(t) {
                "function" == typeof e ? e(t) : Shopify.onItemAdded(t, k, selectedCount)
            },
            error: function(t, r) {
                Shopify.onError(t, r);
            }
        };
    jQuery.ajax(a);
}

var cnt_ = 0;
Shopify.onItemAdded = function(t, k, selectedCount) {
        cnt_++;
        if (config.oneClickCheckout == true) {
            window.location.href = "/checkout";
        } else {
            if (config.redirectToCart == false) {
                posTop = cnt_ * 40 + "px";
                $("#snackbar").append('<div  style="top:' + posTop + ';"  class="wd-ma-snackbar snackbar  ' + t.id + '" >' + t.title + " was added to your shopping cart.</div>");
                jQuery('.' + t.id).show().delay(3000).fadeOut(1000)
                if (cnt_ == selectedCount) {

                    setTimeout(function() {
                        if (Shopify.theme.theme_store_id == '829' || Shopify.theme.theme_store_id == '719') {
                            window.location.reload(true)
                        }
                    }, 2000);
                    //all items added to cart
                }
            } else {
                window.location.href = "/cart";
            }
        }
    },
    Shopify.addItem = function(t, r, e, k, selectedCount) {
        var r = r || 1,
            a = {
                type: "POST",
                url: "/cart/add.js",
                data: "quantity=" + r + "&id=" + t,
                dataType: "json",
                async: false,
                success: function(t) {
                    "function" == typeof e ? e(t) : Shopify.onItemAdded(t, k, selectedCount)
                },
                error: function(t, r) {
                    Shopify.onError(t, r);
                }
            };
        jQuery.ajax(a);
    },
    Shopify.onError = function(t, r) {
        var e = eval("(" + t.responseText + ")");
        //e.message ? alert(e.message + "(" + e.status + "): " + e.description) : alert("Error : " + Shopify.fullMessagesFromErrors(e).join("; ") + ".")
     e.message ? alert( e.description) : alert("Error : " + Shopify.fullMessagesFromErrors(e).join("; ") + ".")
      
}, Shopify.fullMessagesFromErrors = function(t) {
        var r = [];
        return jQuery.each(t, function(t, e) {
            jQuery.each(e, function(e, a) {
                r.push(t + " " + a)
            })
        }), r
    }

function addstocart() {
    cnt_ = 0;
    var wdVariantId;
    var k = 0;
    var selectedCount = 0;
    jQuery('.wd-quick-view').each(function() {
        if (jQuery(this).is(':checked')) {
            selectedCount++;
        }
    });
    if (selectedCount > 0) {
        jQuery('.wd-quick-view').each(function() {
            if (jQuery(this).is(':checked')) {
                k++;
                wdVariantId = jQuery(this).parent().find('.selected-variant-id').text();
              if(wdVariantId!='outofstock'){
                qty = jQuery(this).parent().find('.qty-box').val();
                //alert(k)
                if (Shopify.theme.theme_store_id = '719') {
                    // setTimeout(function(){
                    addItems(wdVariantId, qty, null, k, selectedCount);
                    // },200);
                } else {
                    Shopify.addItem(wdVariantId, qty, null, k, selectedCount);
                }
            }
            }
            

        });
    } else {
        alert(config.selectProductMessage);
    }
};